import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';  

@Pipe({
  name: 'keyword'
})
export class KeywordPipe implements PipeTransform {

  //isEqual == false 模糊查詢
  //getAllStr 符合此特殊字 撈取全部
  transform(List: Array<object>, Field: any, Keyword: string , getAllStr : string=null , isEqual:boolean=false): any {
    console.log('QQ !')
    if(!List || List.length<1) {
      console.log('資料筆數少於1 !')
      return List;
    }

    if(Keyword!=null && Keyword!=undefined){
      Keyword = Keyword.toString()
    }
    if(getAllStr!=null && getAllStr!=undefined){
      getAllStr = getAllStr.toString()
    }    

    if(!Keyword || Keyword.trim().length<1) {   
      console.log(Field+'關鍵字為空')
      return List;
    }
    //特殊值可取得全部
    if(getAllStr && Keyword == getAllStr
    ){
      return List;
    }
    // console.log(333)
    //欄位只有一個 用字串表示
    if(typeof(Field) == 'string'){ 
      //判斷欄位有效
      if(_.keys(List[0]).findIndex(e=>e==Field) == -1 ) {
        console.log(`資料沒有${Field}欄位 !`)
        return List;
      }
      //回傳查詢資料
      let result = _.filter(List,data => {   
        if(!isEqual)
          return  data[Field] && data[Field].toString().indexOf(Keyword) > -1     
        else
          return  data[Field] && data[Field].toString() == Keyword              
      });      
      // console.log(result)
      return   result

    }
    //欄位多個 用陣列表示
    else if (Array.isArray(Field)){
       //判斷欄位有效
      let valid_field = []
      let dataKey = _.keys(List[0])
      Field.forEach(f=>{
        if(dataKey.findIndex(e=>e==f) == -1 ) {
          console.log(`資料沒有${f}欄位 !`)
        }
        else valid_field.push(f) 
      })

     //回傳查詢資料
      return  _.filter(List,data=>{ 
        return valid_field.findIndex(f=>{
          if(!isEqual)
            return data[f] && data[f].toString().indexOf(Keyword)>-1
          else
            return  data[f] && data[f].toString() == Keyword  
        }) > -1          
      })
    }
    else 
      return List;
    


    
      
 
    
  }

}
